import { Quote } from '../../types/quote';
import { __, sprintf } from '@wordpress/i18n';
import { QUOTE_STATUS } from '../../constants';
import { dateI18n, getSettings } from '@wordpress/date';

interface QuoteNoticeProps {
    quote: Quote;
}

const QuoteNotice: React.FC< QuoteNoticeProps > = ( { quote } ) => {
    const expiry_days = quote?.enable_expiry_date ? quote?.expiry_days : 0;

    const statusConfig: Record< keyof typeof QUOTE_STATUS, StatusConfig > = {
        [ QUOTE_STATUS.CANCEL ]: {
            text: __( 'The Quote is Cancelled by the Customer.', 'dokan' ),
            className: 'border-[#E64B5F] bg-[#FFE5E5]',
        },
        [ QUOTE_STATUS.ACCEPTED ]: {
            text:
                expiry_days > 0
                    ? sprintf(
                          __(
                              'The Quote is Accepted by the Customer. Please convert it before the quote expires on %1$s%2$s%3$s.',
                              'dokan'
                          ),
                          '<strong class="font-semibold">',
                          dateI18n(
                              getSettings().formats.date,
                              quote?.expiry_formatted_date,
                              getSettings().timezone.string
                          ),
                          '</strong>'
                      )
                    : __( 'The Quote is Accepted by the Customer', 'dokan' ),
            className: 'border-[#1B6384] bg-[#C0E1F8]',
        },
        [ QUOTE_STATUS.UPDATED ]: {
            text: __(
                'Updated Quote has been sent successfully to the customer. Wait for response.',
                'dokan'
            ),
            className: 'border-[#7c2d12] bg-[#fed7aa]',
        },
        [ QUOTE_STATUS.PENDING ]: {
            text:
                expiry_days > 0
                    ? sprintf(
                          __(
                              'Please be Aware that the Quote Will Expire After %1$s%2$s days from the Approval%3$s.',
                              'dokan'
                          ),
                          '<strong class="font-semibold">',
                          expiry_days,
                          '</strong>'
                      )
                    : '',
            className: 'border-[#7047EB] bg-[#F4F1FE]',
        },
        [ QUOTE_STATUS.APPROVE ]: {
            text:
                expiry_days > 0
                    ? sprintf(
                          __(
                              'The quote will expire on %1$s%2$s%3$s.',
                              'dokan'
                          ),
                          '<strong class="font-semibold">',
                          dateI18n(
                              getSettings().formats.date,
                              quote?.expiry_formatted_date,
                              getSettings().timezone.string
                          ),
                          '</strong>'
                      )
                    : '',
            className: 'border-[#EFBB40] bg-[#FFF8E6]',
        },
        [ QUOTE_STATUS.EXPIRED ]: {
            text:
                expiry_days > 0
                    ? sprintf(
                          __(
                              'The quote expired after %1$s%2$s%3$s.',
                              'dokan'
                          ),
                          '<strong class="font-semibold">',
                          dateI18n(
                              getSettings().formats.date,
                              quote?.expiry_formatted_date,
                              getSettings().timezone.string
                          ),
                          '</strong>'
                      )
                    : '',
            className: 'border-[#E64B5F] bg-[#FFE5E5]',
        },
        [ QUOTE_STATUS.CONVERTED ]: {
            text: quote?.converted_by
                ? sprintf(
                      __(
                          'The Quote Has been Converted to an Order%1$s.',
                          'dokan'
                      ),
                      quote?.show_converter
                          ? sprintf(
                                ' By %1$s%2$s%3$s',
                                '<strong class="font-semibold">',
                                quote?.converted_by,
                                '</strong>'
                            )
                          : ''
                  )
                : '',
            className: 'border-[#00BC8B] bg-[#E3FFF1]',
        },
        [ QUOTE_STATUS.REJECT ]: {
            text: '',
            className: '',
        },
        [ QUOTE_STATUS.TRASH ]: {
            text: '',
            className: '',
        },
    };

    const status = statusConfig[ quote?.status ];
    if ( ! status?.text ) return null;

    return (
        <div
            className={ `px-5 py-2.5 rounded shadow border-l-4 ${ status?.className }` }
        >
            <span
                className="text-[#393939]"
                dangerouslySetInnerHTML={ { __html: status?.text } }
            />
        </div>
    );
};

export default QuoteNotice;
